import clsx from 'clsx';
import {
  default as MUITextField,
  StandardTextFieldProps as MUIStandardTextFieldProps,
  OutlinedTextFieldProps as MUIOutlineTextFieldProps
} from '@material-ui/core/TextField';

import './TextField.css';

//
// --- Types ---

export type TextFieldProps = MUIStandardTextFieldProps | MUIOutlineTextFieldProps;

//
// --- TextField Component ---

const TextField: React.FC<TextFieldProps> = props => {
  const { className, InputLabelProps = {}, ...remainingTextFieldProps } = props;
  const { shrink, ...remainingInputLabelProps } = InputLabelProps;

  return (
    <MUITextField
      className={clsx(['textfield', className])}
      InputLabelProps={{ shrink: true, ...remainingInputLabelProps }}
      {...remainingTextFieldProps}
    />
  );
};
export default TextField;
